var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import FolderDomainService from "../Domain/Folder/Folder.service";
const BASE_URL = "/aviso/folder";
export default class FolderService {
    static create(folderCreateRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/create", folderCreateRequest).then(FolderDomainService.fromJSON);
        });
    }
    static getFoldersForCurrentUser(personType) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(BASE_URL + "/getFoldersForCurrentUser?personType=" + personType);
        });
    }
    static edit({ folderId, name }) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/edit", {
                folderId,
                name,
            });
        });
    }
    static delete(folderId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/delete", {
                folderId,
            });
        });
    }
    static addPopulationToFolder(folderId, populationId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/addPopulationToFolder", {
                folderId,
                populationId,
            });
        });
    }
    static removePopulationFromFolder(folderId, populationId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/removePopulationFromFolder", {
                folderId,
                populationId,
            });
        });
    }
}
